<template>
  <el-col :span="24" class="main">
    <!--右侧内容区-->
    <section class="content-container">
      <div class="grid-content bg-purple-light">
        <el-col :span="24" class="content-wrapper">
          <transition name="fade" mode="out-in">
            <router-view></router-view>
          </transition>
        </el-col>
      </div>
    </section>
  </el-col>
</template>
<script>
  export default {
    name: 'mainNav',
    data () {
      return {
        collapsed: this.$store.state.collapsed,
      }
    },
    methods: {
      //折叠导航栏
      collapse: function () {
        this.collapsed = !this.collapsed;
        this.$store.state.collapsed = this.collapsed;
      },

    },
    created(){

    },
    mounted() {
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/nav/mainNav.vue